import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpEventType } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './user.service';
import { map } from 'rxjs/operators';
import { WebServices } from '../shared/models/enum/web-services.enum';
import { ConsumerService } from '../shared/services/consumer.service';
import { Subject } from 'rxjs';
import { ObsidiamJweComponent } from 'projects/obsidiam-jwe/src/public-api';
@Injectable({
  providedIn: 'root'
})
export class OtcService {
  loggedData: any = {};
  hideTakerOrderModalEvent$: Subject<Boolean> = new Subject<Boolean>();
  baseUrl: any = environment.apiUrl + 'otc/';
  obsicashUrl: any = environment.apiObsicashUrl;
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private obsidiamJweComponent: ObsidiamJweComponent,
    private userService: UserService
  ) {
    const data = this.cookieService.get(environment.authName);
    // console.log(data);
    try {
      this.loggedData = data ? JSON.parse(data) : {};
    } catch (e) {
      this.cookieService.delete(environment.authName);
      this.loggedData = {};
    }
  }
  getOrders(data, token) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'get-orders', data, { headers });
  }
  getOrdersByUsername(username, page, size) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-orders-by-username?username=' + username + '&pageNo=' + page + '&size=' + size, { headers });
  }
  getAvailableBanks(token) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(this.baseUrl + 'get-available-banks', { headers });
  }
  getAvailablePaymeentMethods(token) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(this.baseUrl + 'get-available-payment-methods', { headers });
  }
  getSavedPaymeentMethods(token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-saved-payment-methods', { headers });
  }
  getCountries(token) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
    return this.http.get(this.baseUrl + 'get-countries', { headers });
  }
  getGiftCards() {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
    return this.http.get(this.baseUrl + 'get-gift-cards', { headers });
  }
  createOrder(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'create-order', data, { headers });
  }

  updateOffer(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-offer', data, { headers });
  }
  validatePriceEquation(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'validate-price-equation', data, { headers });
  }
  validateEquation(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'validate-equation', data, { headers });
  }
  getTakerOrders(p, ps, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-taker-orders?pageNo=' + p + '&size=' + ps, { headers });
  }
  getOrderCategory() {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'order-categories', { headers });
  }
  getAllOrders(privateOrder, status, p, ps) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-all-orders?privateOrder=' + privateOrder + '&orderStatus=' + status + '&pageNo=' + p + '&size=' + ps, { headers });
  }
  // getObsicashOrders(p, ps) {
  //   const loggedData = this.userService.getLoggedData();
  //   const tokenData = this.userService.getToken();
  //   const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
  //   return this.http.get(this.baseUrl + 'get-obsicash-orders' + '?pageNo=' + p + '&size=' + ps, { headers });
  // }
  getMakerOrders(privateOrder, p, ps, coin = '', status, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    // tslint:disable-next-line: max-line-length
    return this.http.get(this.baseUrl + 'get-maker-orders?privateOrder=' + privateOrder + '&coinShortName=' + coin + '&pageNo=' + p + '&size=' + ps + '&orderStatus=' + status, { headers });
  }

  getMakerOrdersPrivate(p, ps, status) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    // tslint:disable-next-line: max-line-length
    return this.http.get(this.baseUrl + 'get-maker-orders?' + 'pageNo=' + p + '&size=' + ps + '&orderStatus=' + status, { headers });
  }

  getOrderDetails(id) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    // tslint:disable-next-line: max-line-length
    return this.http.get(this.baseUrl + 'get-offer-details?id=' + id, { headers });
  }
  getPrivateOrder(privateId) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    // tslint:disable-next-line: max-line-length
    return this.http.get(this.baseUrl + 'get-private-order?privateId=' + privateId, { headers });
  }
  takeOrder(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'take-order', data, { headers });
  }
  uploapDocument(data, progress = true) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token)
      .set('Accept', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    if (progress) {
      return this.http.post(this.baseUrl + 'upload-doument', data,
        { headers, reportProgress: true, observe: 'events' }).pipe(map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const p = Math.round(100 * event.loaded / event.total);
              return { status: 'progress', message: p };
            case HttpEventType.Response:
              return event.body;
            default:
              if (!environment.production) {
                console.log(`Unhandled event: ${event.type}`);
              }
              return {};
          }
        })
        );
    } else {
      return this.http.post(this.baseUrl + 'upload-doument', data, { headers });
    }
  }
  getDataForApproval(orderActionId, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-data-for-approval?orderActionId=' + orderActionId, { headers });
  }
  approveOrder(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'approve-order', data, { headers });
  }
  submitFeedback(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'submit-feedback', data, { headers });
  }
  getTraidWindowDetail(actionId, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-trade-window-details?orderActionId=' + actionId, { headers });
  }
  updatePaymentStatus(orderId, verificationCode, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'update-payment-status?orderActionId=' + orderId + '&verificationCode=' + verificationCode, { headers });
  }
  paymentReceived(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'payment-received', data, { headers });
  }
  cancelOrder(orderId, verificationCode = '') {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'cancel-order', { id: orderId, verificationCode }, { headers });
  }
  cancelOrderById(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'cancel-order', data, { headers });
  }
  triggerDispute(data, token) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'trigger-dispute', data, { headers });
  }
  getMessages(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'get-messages', data, { headers });
  }
  getMessagesCount(orderActionId) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-message-count?orderActionId=' + orderActionId, { headers });
  }
  sendMessage(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'send-message', data, { headers });
  }
  getFeedbacks(feedbackType, p, ps) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-feedbacks?feedbackType=' + feedbackType + '&pageNo=' + p + '&size=' + ps, { headers });
  }
  getFeedbacksByUsername(username, feedbackType, p, ps) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-feedbacks-by-username?username=' + username + '&feedbackType=' + feedbackType + '&pageNo=' + p + '&size=' + ps, { headers });
  }
  getFee() {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-fee', { headers });
  }
  allCommissionsConfig(lng) {
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', lng !== '' ? lng : loggedData.preferredLanguage || loggedData.locale);
    return this.obsidiamJweComponent.mapObservable(this.http.get(this.obsicashUrl + '/obsidiam-api/obsicash-service/v1/allCommissionsConfig', { headers }));
  }
  getAllWebsiteReputation() {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.baseUrl + 'get-reputation', { headers });
  }
  deleteFile(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'delete-message', data, { headers });
  }
  deleteReputation(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'delete-imported-reputation', data, { headers });
  }
  updateReputation(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-reputation-import', data, { headers });
  }
  deletePaymentMethod(id) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'delete-payment-method-details', { id }, { headers });
  }
  updatePaymentMethod(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'update-payment-method-details', data, { headers });
  }
  showHideOffer(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'show-hide-offer', data, { headers });
  }
  requestReputation(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'request-import-reputation', data, { headers });
  }
  increasePaymentTime(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    if (!environment.production) {
      // console.log('INCREASE TIME', loggedData);
    }
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'request-increase-time', data, { headers });
  }
  actionIncreasePaymentTime(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.post(this.baseUrl + 'approve-increase-time-request', data, { headers });
  }
  getObsicashFee(lng) {
    const loggedData = this.userService.getLoggedData();
    // console.log(loggedData.preferredLanguage || loggedData.locale);
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', lng);
    return this.http.get(this.obsicashUrl + '/obsidiam-api/obsicash-service/v1/commissionsConfig', { headers });
  }

  getcalculateCommission(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);

    return this.http.post(this.baseUrl + 'calculate-commission', data, { headers })
  }
  updateTitleDocument(data) {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);

    return this.http.post(this.baseUrl + 'update-title-transfer-doc', data, { headers })
  }

  getParmetersLimit() {
    const loggedData = this.userService.getLoggedData();
    const tokenData = this.userService.getToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenData.token).set('Content-Type', 'application/json; charset=utf-8').set('Accept-Language', loggedData.preferredLanguage || loggedData.locale);
    return this.http.get(this.obsicashUrl + environment.jweUrls.URL_GET_PARAMETERP2P.url, { headers });
  }
}
